import { render, staticRenderFns } from "./paymentBank.vue?vue&type=template&id=00ebbd45&scoped=true"
import script from "./paymentBank.vue?vue&type=script&lang=js"
export * from "./paymentBank.vue?vue&type=script&lang=js"
import style0 from "./paymentBank.vue?vue&type=style&index=0&id=00ebbd45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ebbd45",
  null
  
)

export default component.exports